import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface InternalNotifications {
  name: string;
  api_token: string;
}

export interface InternalNotificationsListInfor {
  errors: unknown;
  internalNotifications: InternalNotifications;
  isAuthenticated: boolean;
}

@Module
export default class InternalNotificationsModule
  extends VuexModule
  implements InternalNotificationsListInfor
{
  errors = {};
  internalNotifications = {} as InternalNotifications;
  isAuthenticated = !!JwtService.getToken();

  get InternalNotifications() {
    return this.internalNotificationsListData;
  }

  @Mutation
  [Mutations.INTERNAL_NOTIFICATIONS_LIST_DATA](InternalNotifications) {
    this.internalNotificationsListData = InternalNotifications;
  }

  @Action
  [Actions.INTERNAL_NOTIFICATIONS_LIST](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("/thongbaonoibo", payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_NOTIFICATIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_NOTIFICATION_CREATE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.post("thongbaonoibo/upsert", payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_NOTIFICATIONS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_NOTIFICATION_UPDATE](payload) {
    const id = payload.get("id");
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail("/thongbaonoibo", "upsert", id, payload)
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_NOTIFICATIONS_LIST_DATA, data);
          this.context.commit(Mutations.SET_ERROR, {});
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }

  @Action
  [Actions.INTERNAL_NOTIFICATION_DELETE](payload) {
    if (JwtService.getToken()) {
      ApiService.setHeader();
      return ApiService.getDataDetail(
        "/thongbaonoibo",
        payload,
        "delete",
        payload
      )
        .then((data) => {
          this.context.commit(Mutations.INTERNAL_NOTIFICATIONS_LIST_DATA, data);
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
        });
    } else {
      this.context.commit(Mutations.PURGE_AUTH);
    }
  }
}
